export const config = {
    api: {
        baseUrl: 'https://api-terminal-web-efleet.justit.cloud/api',
        timeout: 30000,
    },
    encryption: {
        enabled: true,
    },
    features: {
        xmlUpload: true,
        emailReceipt: true,
        printReceipt: true,
    },
} as const;

